/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Alert action
 */
export type ReadAlertResponseDtoAction =
  (typeof ReadAlertResponseDtoAction)[keyof typeof ReadAlertResponseDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadAlertResponseDtoAction = {
  updated: 'updated',
  saved: 'saved',
  draft: 'draft',
  RRARequested: 'RRARequested',
  RRACompleted: 'RRACompleted',
} as const;
